import GavelIcon from '@mui/icons-material/Gavel'
import { Avatar, Box, Container, Link, Typography } from '@mui/material'

import { Wrapper, AppBarR as PersistentDrawerRight } from '../components/common'

import routes from './routes'

const TermsOfService = () => {
  return (
    <>
      <PersistentDrawerRight></PersistentDrawerRight>
      <Wrapper>
        <Container component='main' maxWidth='md'>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              py: 4
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
              <Avatar sx={{ bgcolor: 'primary.main', width: 32, height: 32 }}>
                <GavelIcon fontSize='small' />
              </Avatar>
              <Typography component='h1' variant='h6' sx={{ fontWeight: 600 }}>
                Terms of Service
              </Typography>
            </Box>

            <Typography
              variant='body2'
              sx={{ mb: 4, color: 'text.secondary', fontStyle: 'italic' }}
            >
              Last Updated: March 19, 2026
            </Typography>

            <Typography variant='body1' sx={{ mb: 3, lineHeight: 1.7 }}>
              Please read these Terms of Service ("Terms") carefully before
              using the [App Name] desk booking platform (the "Service")
              operated by [Your Company Name] ("us", "we", or "our").
            </Typography>

            <Typography
              variant='h6'
              sx={{ fontWeight: 600, mb: 2, mt: 3, color: 'primary.main' }}
            >
              1. Acceptance of Terms
            </Typography>
            <Typography variant='body1' sx={{ mb: 3, lineHeight: 1.7 }}>
              By accessing or using the Service, you agree to be bound by these
              Terms. If you disagree with any part of the terms, you may not
              access the Service.
            </Typography>

            <Typography
              variant='h6'
              sx={{ fontWeight: 600, mb: 2, mt: 3, color: 'primary.main' }}
            >
              2. Nature of Service ("As Is")
            </Typography>
            <Typography variant='body1' sx={{ mb: 2, lineHeight: 1.7 }}>
              The Service is provided on an <strong>"AS IS"</strong> and{' '}
              <strong>"AS AVAILABLE"</strong> basis. To the maximum extent
              permitted by law, we disclaim all warranties, express or implied,
              including fitness for a particular purpose.
            </Typography>
            <Box component='ul' sx={{ pl: 3, mb: 3 }}>
              <li>
                <Typography variant='body1' sx={{ lineHeight: 1.7 }}>
                  We do not warrant that the Service will be uninterrupted,
                  error-free, or that any desk booking will be guaranteed.
                </Typography>
              </li>
              <li>
                <Typography variant='body1' sx={{ lineHeight: 1.7 }}>
                  Logistics, physical workspace availability, and coordination
                  remain the sole responsibility of the User.
                </Typography>
              </li>
            </Box>

            <Typography
              variant='h6'
              sx={{ fontWeight: 600, mb: 2, mt: 3, color: 'primary.main' }}
            >
              3. Limitation of Liability (The "Productivity" Clause)
            </Typography>
            <Typography variant='body1' sx={{ mb: 2, lineHeight: 1.7 }}>
              <strong>
                TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT
                SHALL [YOUR COMPANY NAME] BE LIABLE FOR ANY INDIRECT, PUNITIVE,
                INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR EXEMPLARY DAMAGES.
              </strong>
            </Typography>
            <Typography variant='body1' sx={{ mb: 2, lineHeight: 1.7 }}>
              This includes, without limitation, damages for:
            </Typography>
            <Box component='ul' sx={{ pl: 3, mb: 3 }}>
              <li>
                <Typography variant='body1' sx={{ lineHeight: 1.7 }}>
                  <strong>Loss of productivity</strong> or business
                  interruption.
                </Typography>
              </li>
              <li>
                <Typography variant='body1' sx={{ lineHeight: 1.7 }}>
                  Loss of profits, goodwill, or data.
                </Typography>
              </li>
              <li>
                <Typography variant='body1' sx={{ lineHeight: 1.7 }}>
                  Costs associated with staff being unable to access a physical
                  workspace.
                </Typography>
              </li>
              <li>
                <Typography variant='body1' sx={{ lineHeight: 1.7 }}>
                  Workplace disputes arising from the use of the booking system.
                </Typography>
              </li>
            </Box>

            <Typography
              variant='h6'
              sx={{ fontWeight: 600, mb: 2, mt: 3, color: 'primary.main' }}
            >
              4. Financial Cap on Liability
            </Typography>
            <Typography variant='body1' sx={{ mb: 3, lineHeight: 1.7 }}>
              Our total liability for any claims arising out of or relating to
              these Terms or the Service is limited to the{' '}
              <strong>
                total amount you paid to us to use the Service in the 12 months
                preceding the event giving rise to the claim.
              </strong>
            </Typography>

            <Typography
              variant='h6'
              sx={{ fontWeight: 600, mb: 2, mt: 3, color: 'primary.main' }}
            >
              5. Service Level & Sole Remedy
            </Typography>
            <Typography variant='body1' sx={{ mb: 3, lineHeight: 1.7 }}>
              While we strive for high uptime, we do not guarantee 100%
              availability. Your <strong>sole and exclusive remedy</strong> for
              any Service outage or technical failure is a service credit toward
              future subscription fees, at our sole discretion.
            </Typography>

            <Typography
              variant='h6'
              sx={{ fontWeight: 600, mb: 2, mt: 3, color: 'primary.main' }}
            >
              6. User Responsibilities
            </Typography>
            <Typography variant='body1' sx={{ mb: 3, lineHeight: 1.7 }}>
              You are responsible for maintaining the confidentiality of your
              account and password. You agree to accept responsibility for all
              activities that occur under your account.
            </Typography>

            <Typography
              variant='h6'
              sx={{ fontWeight: 600, mb: 2, mt: 3, color: 'primary.main' }}
            >
              7. Termination
            </Typography>
            <Typography variant='body1' sx={{ mb: 3, lineHeight: 1.7 }}>
              We may terminate or suspend access to our Service immediately,
              without prior notice or liability, for any reason whatsoever,
              including without limitation if you breach the Terms.
            </Typography>

            <Typography
              variant='h6'
              sx={{ fontWeight: 600, mb: 2, mt: 3, color: 'primary.main' }}
            >
              8. Governing Law
            </Typography>
            <Typography variant='body1' sx={{ mb: 3, lineHeight: 1.7 }}>
              These Terms shall be governed and construed in accordance with the
              laws of <strong>New South Wales, Australia</strong>, without
              regard to its conflict of law provisions.
            </Typography>

            <Box
              sx={{
                mt: 4,
                p: 3,
                bgcolor: 'background.paper',
                borderRadius: 2,
                border: '1px solid',
                borderColor: 'divider'
              }}
            >
              <Typography
                variant='body2'
                sx={{ color: 'text.secondary', textAlign: 'center' }}
              >
                For more information about how we handle your data, please see
                our{' '}
                <Link
                  href={routes.privacyPolicy}
                  sx={{
                    color: 'primary.main',
                    fontWeight: 500,
                    textDecoration: 'none',
                    '&:hover': {
                      textDecoration: 'underline'
                    }
                  }}
                >
                  Privacy Policy
                </Link>
                .
              </Typography>
            </Box>
          </Box>
        </Container>
      </Wrapper>
    </>
  )
}

export default TermsOfService
